import { Literal, Static, Union } from "runtypes";

import { AgentChatRunId } from "../../idTypeBrands";
import { getNormalEnum } from "../../runtypeEnums";

export const AgentChatThreadTypeLiteral = Union(
  // MagicEvent-based threads
  Literal("LOGIC_VIEW"),
  // AgentChatMessage-based threads
  Literal("LOGIC_VIEW_V2"),
  Literal("ASK"),
  Literal("REVIEW"),
  Literal("SEMANTIC_AUTHORING"),
  Literal("CHAT_WITH_APP"),
  // Unused/dormant
  Literal("EXPLORE"),
);
export type AgentChatThreadType = Static<typeof AgentChatThreadTypeLiteral>;
export const AgentChatThreadType = getNormalEnum(AgentChatThreadTypeLiteral);

/**
 * Types that only appear as subagent identifiers, never as AgentChatThread.type in the DB.
 */
export const AgentSubagentTypeLiteral = Union(
  Literal("DATA_DISCOVERY"),
  Literal("VISUALIZATION"),
  Literal("DATA_APP"),
);
export type AgentSubagentType = Static<typeof AgentSubagentTypeLiteral>;
export const AgentSubagentType = getNormalEnum(AgentSubagentTypeLiteral);

/**
 * Combined type covering both user-facing thread types and subagent-only types.
 */
export type AgentChatThreadOrSubagentType =
  | AgentChatThreadType
  | AgentSubagentType;

export type LogicViewChatState = "closed" | "chat" | "history";
export const AgentEntryPointLiteral = Union(
  Literal("FIX_CELL_WITH_AGENT"),
  Literal("SLACK"),
  Literal("MCP"),
  Literal("AGENT_SUGGESTION"),
  Literal("CONTEXT_WORKBENCH_PREVIEW"),
  Literal("SEMANTIC_PROJECT_WORKBENCH_PREVIEW"),
);
export type AgentEntryPoint = Static<typeof AgentEntryPointLiteral>;
export const AgentEntryPoint = getNormalEnum(AgentEntryPointLiteral);

export type AppAgentChatState = "closed" | "chat" | "history";

/**
 * Context for subagent message isolation.
 * Contains both the subagent type and a unique invocation ID.
 */
export interface SubagentContext {
  subagentType: AgentSubagentType;
  subagentInvocationId: AgentChatRunId;
}

/**
 * Status for queued prompts in an agent chat thread.
 */
export const QueuedPromptStatusLiteral = Union(
  /** Prompt is waiting to be processed */
  Literal("PENDING"),
  /** Prompt is marked to be injected into the current agent run */
  Literal("FORCED"),
);
export type QueuedPromptStatus = Static<typeof QueuedPromptStatusLiteral>;
export const QueuedPromptStatus = getNormalEnum(QueuedPromptStatusLiteral);

export * from "./agentChatMessageTypes";
